// SocketComponent.js
import { useEffect } from "react";
import io from "socket.io-client";
import { signInSocket } from "../../config/TokenHelper";

// Socket URL from environment variable
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5001";

const SocketComponent = ({ onNewNotification }) => {
  useEffect(() => {
    const isSecure = SOCKET_URL.startsWith("https");
    const socketConnection = io.connect(SOCKET_URL, { secure: isSecure });

    // Signs in on connect and again on every reconnect, so the backend
    // rejoins the admin room.
    signInSocket(socketConnection);

    socketConnection.on("connected", () => {
      console.log("Socket Connected");
    });

    socketConnection.on("new-notification-received", (data) => {
      onNewNotification(data);
    });

    return () => {
      if (socketConnection) {
        socketConnection.disconnect();
      }
    };
  }, [onNewNotification]);

  return null;
};

export default SocketComponent;
